// Saved copy of a child's results list, so the Results screen can paint before the network answers.
// It is only ever a first paint: the list is always fetched again, and what the server returns replaces it.
// The key does not start with "sb-", so clearTenantLocalCache() (which keeps only the sign-in session)
// also removes it when a different user signs in; clearResultsCache() removes it at sign-out.
const PREFIX = 'edease.results.';

export const resultsCacheKey = (studentId) => `${PREFIX}${studentId}`;

export function readResultsCache(studentId) {
  try {
    const raw = localStorage.getItem(resultsCacheKey(studentId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.list) ? parsed.list : null;
  } catch {
    return null;   // unreadable or blocked storage: behave as if nothing was saved
  }
}

export function writeResultsCache(studentId, list) {
  try {
    localStorage.setItem(resultsCacheKey(studentId), JSON.stringify({ at: Date.now(), list }));
  } catch {
    /* storage full or blocked: the cache is optional */
  }
}

// Every child's copy (used when results change, and at sign-out)
export function clearResultsCache() {
  try {
    Object.keys(localStorage).filter(k => k.startsWith(PREFIX)).forEach(k => localStorage.removeItem(k));
  } catch {
    /* storage blocked: nothing to clear */
  }
}
